var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasActiveTabs
    ? _c(
        "div",
        {
          key: _vm.activeTabId,
          staticClass: "table-active-tabs",
          on: { click: _vm.closeContextMenu },
        },
        [
          _c(
            "div",
            { staticClass: "tabs-container" },
            [
              _c(
                "a-tooltip",
                { attrs: { title: _vm.table.name, placement: "bottom" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "tab home-tab",
                      class: { active: _vm.activeTabId === "home" },
                      on: {
                        click: function ($event) {
                          return _vm.selectTab("home")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("home"),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.getHomeTitleShort(_vm.table.name))),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.activeTabs, function (tab) {
                return _c(
                  "a-tooltip",
                  {
                    key: "tooltip-" + tab.recordId,
                    attrs: {
                      title: _vm.getFullTabTitle(tab),
                      placement: "bottom",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        key: "tab-" + tab.recordId,
                        staticClass: "tab record-tab",
                        class: { active: _vm.activeTabId === tab.recordId },
                        on: {
                          click: function ($event) {
                            return _vm.selectTab(tab.recordId)
                          },
                          contextmenu: function ($event) {
                            $event.preventDefault()
                            return _vm.onTabRightClick($event, tab)
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "tab-title" }, [
                          _vm._v(_vm._s(_vm.getTabTitle(tab))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a-tooltip",
                          {
                            attrs: {
                              title: "Sekmeyi Kapat",
                              placement: "bottom",
                            },
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons close-btn",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.closeTab(tab.recordId)
                                  },
                                },
                              },
                              [_vm._v("close")]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _vm.contextMenuVisible
            ? _c(
                "div",
                {
                  staticClass: "context-menu",
                  style: {
                    left: _vm.contextMenuX + "px",
                    top: _vm.contextMenuY + "px",
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "context-menu-item",
                      on: {
                        click: function ($event) {
                          return _vm.closeTab(_vm.contextMenuTab.recordId)
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("close"),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v("Kapat")]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "context-menu-item",
                      on: {
                        click: function ($event) {
                          return _vm.closeOtherTabs(_vm.contextMenuTab.recordId)
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("close_fullscreen"),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v("Diğer Sekmeleri Kapat")]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "context-menu-item",
                      class: {
                        disabled: !_vm.canCloseTabsToRight(
                          _vm.contextMenuTab.recordId
                        ),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.closeTabsToRight(
                            _vm.contextMenuTab.recordId
                          )
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("keyboard_arrow_right"),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v("Sağdaki Sekmeleri Kapat")]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "context-menu-item",
                      class: {
                        disabled: !_vm.canCloseTabsToLeft(
                          _vm.contextMenuTab.recordId
                        ),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.closeTabsToLeft(
                            _vm.contextMenuTab.recordId
                          )
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("keyboard_arrow_left"),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v("Soldaki Sekmeleri Kapat")]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }